import React, { useEffect, useState } from "react";
import { Form, Row, Col, Space, Button, Spin } from "antd";

import { InputFields } from "components/common";

import dayjs from "dayjs";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { columns, dataFields } from "./config";
import {dataFields as inputFieldsInit} from "./config";
import Notification from "../../../../../../components/common/notification/notification";
import TableInputAdd from "../TableInputAdd/TableInputAdd";
import { RangePickerProps } from "antd/es/date-picker";
import employeeService from "api/employee";

const FormAdd = (props) => {
  const { data, closeModal, type, setCurrentPage, getListApi } = props;

  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null);
  const [form] = Form.useForm();
  // const employees = useAppSelector(state => state.employeesReducer);

  const [dataTable, setData] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const dispatch = useAppDispatch();
  const [count, setCount] = useState(1);
  // useEffect(() => {
  //   newId();
  // }, [type]);
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("thoiGianApDungDen");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("thoiGianApDungTu");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "thoiGianApDungTu").disabledDate = disabledDateStart;
    inputFieldsInit.find(e => e.name == "thoiGianApDungDen").disabledDate = disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
      newId();
      setData([]);
      form.setFieldValue("maBieuThue", id);
    } else {
      form.setFieldsValue({
        ...data,
        thoiGianApDungTu: data?.thoiGianApDungTu
          ? dayjs(data.thoiGianApDungTu)
          : null,
        thoiGianApDungDen: data?.thoiGianApDungDen
          ? dayjs(data.thoiGianApDungDen)
          : null,
      });
    }
    setLoading(false);
  }, [data, id]);
  const getListModal = async () => {
    if (data !== null) {
      setLoading(true);
      try {
        const response = await employeeService.searchTNCNNop(data?.id);
        const newRes = response.map((item) => ({ ...item, key: item.id }));
        setData(newRes);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        
        Notification("error", "Đã có lỗi xảy ra khi lấy biểu thuế");
      }
    }
  };
  const onSelectRow = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  useEffect(() => {
    getListModal();
  }, [data]);
  const addApi = async () => {
    setLoading(true);
    const value = await form.validateFields();
    try {
      const params = {
        ...value,
        bieuThueTNCNPhaiNop: dataTable,
      };
      await employeeService.updateTNCN(params).then((res) => {
        if (res.code === 400) {
          Notification("error", res.message);
          setLoading(false);
        } else {
          Notification("success", "Đã thêm mới thành công ");
        }
      });
      setLoading(false);
      newId();
      closeModal();
      getListApi();
      form.resetFields();
      setData([]);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm mới biểu thuế");
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();

    try {
      const params = {
        ...value,
        id: data.id,
        bieuThueTNCNPhaiNop: dataTable,
      };
      const res = await employeeService.updateTNCN(params).then((res) => {
        if (res.code === 400) {
          Notification("error", res.message);
        } else {
          Notification("success", "Đã sửa thành công");
        }
      });
      setLoading(false);
      closeModal();
      getListApi();
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin biểu thuế ");
    }
  };
  const newId = async () => {
    try {
      const res = await employeeService.getNewIdBT(id);
      setId(res);
      form.setFieldValue("maBieuThue", res);
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy mã đợt biểu thuế");
    }
  };
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = (
      currentDate
    ) => {
      const endDay = form.getFieldValue("thoiGianApDungDen");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = (currentDate) => {
      const start = form.getFieldValue("thoiGianApDungTu");
      if (start) {
        return currentDate < start;
      }
    };
    // inputFieldsInit.find(e => e.name == "thoiGianApDungTu").disabledDate =
    //     disabledDateStart;
    // inputFieldsInit.find(e => e.name == "thoiGianApDungDen").disabledDate = disabledDateEnd;
    // setInputFields([...inputFieldsInit]);
  }, []);
  const onFinish = (values) => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} 
        onFinish={onFinish}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <div className="container" style={{ marginTop: 12 }}>
              <div className="container-main">
                {dataTable && (
                  <TableInputAdd
                    loading={loading}
                    column={columns}
                    data={dataTable}
                    setData={setData}
                    pagination={false}
                    // rowSelection={{
                    //   type: "checkbox",
                    //   onChange: onSelectRow,
                    //   selectedRowKeys: selectedRowKeys,
                    // }}
                    count={count}
                    setCount={setCount}
                  />
                )}
              </div>
            </div>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAdd;
